import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useAuth } from '@/contexts/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * QuoteSetupGate — see comment in original file.
 */
export const QuoteSetupGate = ({ children }) => {
  const location = useLocation();
  const { user, logout } = useAuth();
  const { t } = useTranslation('quotes');
  const [state, setState] = useState({ loading: true, needsSetup: false, forceOut: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (user?.role === 'superadmin') {
        if (!cancelled) setState({ loading: false, needsSetup: false, forceOut: false });
        return;
      }
      try {
        const { data } = await axios.get(`${API_URL}/api/quote/setup-status`);
        if (cancelled) return;
        if (data.eligible === false) {
          toast.error(t('login.legacyBlocked'), { duration: 8000 });
          await logout();
          setState({ loading: false, needsSetup: false, forceOut: true });
          return;
        }
        setState({ loading: false, needsSetup: !data.setup_completed, forceOut: false });
      } catch {
        if (!cancelled) {
          try { await logout(); } catch { /* noop */ }
          toast.error(t('login.legacyBlocked'), { duration: 8000 });
          setState({ loading: false, needsSetup: false, forceOut: true });
        }
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.role]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
        <p className="text-sm text-[#595959]">{t('common.loading')}</p>
      </div>
    );
  }

  if (state.forceOut) {
    return <Navigate to="/" replace />;
  }

  if (state.needsSetup && location.pathname !== '/quote-setup') {
    return <Navigate to="/quote-setup" replace />;
  }

  return children;
};

export default QuoteSetupGate;
